import { IMemoize } from "./types";
import _ from "lodash";

export const memoize: IMemoize = _.memoize;
